import { ArrowLeft, ArrowRight, Check } from "lucide-react";

// One-question-at-a-time shell, same shape as StartWizard: numbered step row, a card for the current step, Back/Next footer.
export default function Stepper({ steps, step, onStep, children, canNext = true, onBack, onNext, nextLabel = "Next", lastLabel = "Finish", onFinish, finish, busy = false, testid = "stepper", title, aside, stepTestid, maxStep, backLabelFirst = "Back", hideFooter = false }) {
  const last = step === steps.length - 1;
  const reachable = (i) => maxStep === undefined || i <= maxStep;
  return (
    <div data-testid={testid}>
      <ol className="flex flex-wrap items-center gap-x-1 gap-y-2 text-xs font-bold" aria-label={title || "Steps"} data-testid={`${testid}-steps`}>
        {steps.map((s, i) => {
          const done = i < step; const cur = i === step;
          return (
            <li key={s.key} className="flex items-center gap-1">
              <button type="button" data-testid={stepTestid ? stepTestid(s, i) : `${testid}-step-${s.key}`} aria-current={cur ? "step" : undefined} disabled={!reachable(i)} onClick={() => onStep(i)} className={`inline-flex items-center gap-1.5 rounded-full pl-1 pr-2.5 py-0.5 transition-colors disabled:cursor-default ${cur ? "bg-ink text-on-dark" : done ? "text-success-700 hover:bg-success-50" : "text-muted-foreground" + (reachable(i) ? " hover:bg-muted" : "")}`}>
                <span className={`w-5 h-5 rounded-full flex items-center justify-center text-[10px] ${cur ? "bg-card/20" : done ? "bg-success-500 text-on-dark" : "bg-secondary"}`}>{done ? <Check size={11} /> : i + 1}</span>
                <span className="hidden sm:inline">{s.label}</span><span className="sr-only">{done ? " — done" : cur ? " — current" : ""}</span>
              </button>
              {i < steps.length - 1 && <span className="w-3 h-px bg-border hidden sm:block" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
      <div className="pp-card p-6 mt-4">
        <div data-testid={`${testid}-body`} aria-live="polite">{children}</div>
        {!hideFooter && <div className="mt-6 pt-4 border-t border-border-soft flex items-center justify-between gap-3">
          <button type="button" data-testid={`${testid}-back`} disabled={step === 0 && !onBack} onClick={() => (step === 0 ? onBack?.() : onStep(step - 1))} className="pp-btn-ghost disabled:opacity-40"><ArrowLeft size={14} /> {step === 0 ? backLabelFirst : "Back"}</button>
          <div className="flex items-center gap-3">
            {aside}
            {last
              ? (finish || <button type="button" data-testid={`${testid}-finish`} disabled={busy || !canNext} onClick={onFinish} className="pp-btn-dark">{busy ? "Saving…" : lastLabel} <Check size={14} /></button>)
              : <button type="button" data-testid={`${testid}-next`} disabled={!canNext} onClick={() => (onNext ? onNext(step + 1) : onStep(step + 1))} className="pp-btn-dark">{nextLabel} <ArrowRight size={14} /></button>}
          </div>
        </div>}
      </div>
    </div>
  );
}
